import { Injectable, signal } from '@angular/core';
import { AbstractCategoryFormService } from '../../../common/category-details/abstract-category-form-service';
import {
  createNewsCategoryAsync,
  findNewsCategoryAsync,
  updateNewsCategoryAsync,
} from '../../../../backend/main';
import type { CategoryDetailsForm } from '../../../common/category-details/category-details-form';
import type { CategoryDetailsFormValuesWithTopics } from '../../../common/category-details/category-details-form-with-topics';
import { CategoryDetailsFormWithTopics } from '../../../common/category-details/category-details-form-with-topics';

@Injectable()
export class NewsCategoryFormService extends AbstractCategoryFormService<CategoryDetailsFormValuesWithTopics> {
  readonly i18nPrefix = signal('PAGES.NEWS.CATEGORY');

  readonly findCategoryAsync = findNewsCategoryAsync;
  readonly createCategoryAsync = createNewsCategoryAsync;
  readonly updateCategoryAsync = updateNewsCategoryAsync;

  createForm(): CategoryDetailsForm {
    return new CategoryDetailsFormWithTopics();
  }
}
